module.exports = __webpack_public_path__ + "static/CloudBatteryHeroMobile-1e5dc46aa335df8f906a42c10f4c8281.svg";